import { Component, Input, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ReportService } from "../../../services/report.service";
import { take } from 'rxjs/operators';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {
  submissionId: string;

  @ViewChild('toggleButton') toggleButton!: ElementRef<HTMLButtonElement>;

  constructor(private reportService: ReportService, private submissionsService: SubmissionsService, private route: ActivatedRoute, private spinnerService: NgxSpinnerService, private host: ElementRef<HTMLElement>) {
  }

  ngOnInit(): void {
    this.reportService.toggleQuotesObject.subscribe((data) => {
      this.toggleChecked = data;
    });
    this.reportService.toggleAIKeywordsObject.subscribe((data) => {
      this.keywordHighlightEnabled = data;
    });
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.submissionId = params.get('id');
    });

  }

  @Input() isOnAi!: boolean;
  @Input() isOnAnalysis!: boolean;
  @Input() isOnManipulation!: boolean;
  @Input() isAiEnabled: boolean = false;
  @Input() textManipulationEnable: boolean = false;
  // @Input() toggleChecked: boolean
  @Input() context_similarity: boolean;
  toggleChecked: boolean;

  keywordHighlightEnabled: boolean = true;

  // Add aria label for toggle
  toggleAriaLabel = 'Toggle cited text highlighting';
  keywordToggleAriaLabel = 'Toggle AI keyword highlighting';

  // Add keyboard handler for toggle
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleQuotes();
    }
  }

  toggleQuotes() {
    this.toggleChecked = !this.toggleChecked;
    this.reportService.toggleQuotesSubject.next(this.toggleChecked);
    if (this.toggleButton) {
      this.toggleButton.nativeElement.focus();
    }
  }

  onKeywordToggleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleKeywordHighlighting();
    }
  }

  toggleKeywordHighlighting() {
    this.keywordHighlightEnabled = !this.keywordHighlightEnabled;
    this.reportService.toggleAIKeywordsSubject.next(this.keywordHighlightEnabled);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    const openContainers = this.host.nativeElement.querySelectorAll(
      '.legend-tooltip-container:hover, .legend-tooltip-container:focus-within'
    );

    if (!openContainers.length) {
      return;
    }

    openContainers.forEach((el) => el.classList.add('is-dismissed'));
    event.preventDefault();
  }

  @HostListener('mouseout', ['$event'])
  onTooltipMouseOut(event: MouseEvent): void {
    this.clearTooltipDismiss(event.target as Element | null, event.relatedTarget as Node | null);
  }

  @HostListener('focusout', ['$event'])
  onTooltipFocusOut(event: FocusEvent): void {
    this.clearTooltipDismiss(event.target as Element | null, event.relatedTarget as Node | null);
  }

  private clearTooltipDismiss(target: Element | null, relatedTarget: Node | null): void {
    const container = target?.closest?.('.legend-tooltip-container');
    if (!container || !this.host.nativeElement.contains(container)) {
      return;
    }
    if (relatedTarget && container.contains(relatedTarget)) {
      return;
    }
    container.classList.remove('is-dismissed');
  }
}
